module.exports = __webpack_public_path__ + "img/nexultra-active-icon.25fffee6.svg";